/**
 * Suppress SES (Secure EcmaScript) warnings about unpermitted intrinsics
 * These warnings are harmless and occur when core-js polyfills or other libraries
 * include newer JavaScript features that SES doesn't allow in its sandbox
 */
export default function ({ app }) {
  if (process.client) {
    // Store original console methods
    const originalConsoleWarn = console.warn
    const originalConsoleError = console.error
    const originalConsoleLog = console.log

    // Filter SES warnings - comprehensive list
    const shouldSuppress = (message) => {
      if (typeof message !== 'string') {
        message = String(message)
      }
      return (
        message.includes('SES Removing unpermitted intrinsics') ||
        message.includes('Removing intrinsics.%MapPrototype%') ||
        message.includes('Removing intrinsics.%WeakMapPrototype%') ||
        message.includes('Removing intrinsics.%DatePrototype%') ||
        message.includes('lockdown-install.js') ||
        (message.includes('getOrInsert') && message.includes('intrinsics')) ||
        (message.includes('toTemporalInstant') && message.includes('intrinsics'))
      )
    }

    // Override console.warn
    console.warn = function (...args) {
      const message = args.map(arg => 
        typeof arg === 'string' ? arg : JSON.stringify(arg)
      ).join(' ')
      if (shouldSuppress(message)) {
        return // Suppress SES warnings
      }
      originalConsoleWarn.apply(console, args)
    }

    // Override console.error
    console.error = function (...args) {
      const message = args.map(arg => 
        typeof arg === 'string' ? arg : JSON.stringify(arg)
      ).join(' ')
      if (shouldSuppress(message)) {
        return // Suppress SES errors
      }
      originalConsoleError.apply(console, args)
    }

    // Also check console.log in case warnings come through there
    console.log = function (...args) {
      const message = args.map(arg => 
        typeof arg === 'string' ? arg : JSON.stringify(arg)
      ).join(' ')
      if (shouldSuppress(message)) {
        return // Suppress SES logs
      }
      originalConsoleLog.apply(console, args)
    }
  }
}

